import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import i18n from "../../../../../i18n";
import { addModal } from "../../../../../app.logic";
import { modalStyleForm } from "../../../../../utils/constant";
import { initUseForm } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { required, requiredWhen, validateError } from "../../../../../utils/validate";
import { createFieldInputPassword, createFieldRadioGroup } from "../../../../../components/input/template-builder/template-builder.logic";

export const { isLoading, setIsLoading } = createLoading();

export const ConfirmRequestForm = defineAsyncComponent(() => import("./ConfirmRequestForm"));

export const openModalForm = ({ props, onOk, bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.request.modal.request.title"),
                width: "500px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <ConfirmRequestForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></ConfirmRequestForm>
        )
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        isSignCa: null,
        passwordCa: null
    };
};

export const createRules = ({ data }) => {
    return {
        isSignCa: [required],
        passwordCa: [requiredWhen({ when: () => data.useForm.modelRef.isSignCa })]
    };
};

export const createField = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    return [
        createFieldRadioGroup({
            key: "isSignCa",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t("views.request.modal.request.isSignCa"),
            inputProp: () => {
                const yesNo = [
                    { id: "1", name: i18n.global.t("views.request.modal.request.signCa") },
                    { id: "2", name: i18n.global.t("views.request.modal.request.notSignCa") }
                ];
                return {
                    value:
                        modelRef.isSignCa === true
                            ? yesNo.find(d => d.id === "1")
                            : modelRef.isSignCa === false
                            ? yesNo.find(d => d.id === "2")
                            : undefined,
                    "onUpdate:value": value => (modelRef.isSignCa = value.id === "1" ? true : value.id === "2" ? false : undefined),
                    list: () => yesNo
                };
            }
        }),
        createFieldInputPassword({
            key: "passwordCa",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            label: () => i18n.global.t("views.request.modal.request.passwordCa"),
            inputProp: () => {
                if (!modelRef.isSignCa) {
                    modelRef.passwordCa = null;
                }
                return {
                    value: modelRef.passwordCa,
                    "onUpdate:value": value => (modelRef.passwordCa = value),
                    disabled: !modelRef.isSignCa
                };
            }
        })
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
